module.exports = __webpack_public_path__ + "img/main-consign-miniapp.d9d62ac.webp";